import { useFormConnect } from '../../../hooks/useFormConnect'
import { TextInput } from '../RawInputs/TextInput'

export function GenericTextInput({
  name,
  type,
  placeholder,
  label
}: {
  name: string
  type: string
  placeholder: string
  label: string
}) {
  const props = useFormConnect(name)
  return <TextInput placeholder={placeholder} {...props} label={label} type={type} />
}
